import googleGlobalSiteTag from '@/app/utils/googleGlobalSiteTag';

import * as types from './types';

export const setContent = ({ commit }, payload) => {
  commit(types.SET_CONTENT, payload);
};

export const initialize = ({ dispatch, rootGetters }, packageName) => {
  const packageBlueprint = rootGetters['packages/getPackage'](packageName);
  const _package = {};

  Object.keys(packageBlueprint.modules).forEach((moduleName) => {
    const $module = packageBlueprint.modules[moduleName];
    const moduleBlueprint = rootGetters['modules/getModule'](moduleName);
    const _components = {};

    Object.keys($module.components).forEach((componentName) => {
      Object.assign(_components, {
        [componentName]: {
          ...moduleBlueprint.components[componentName],
          ...$module.components[componentName]
        }
      });

      // loop over subcomponents
      if ($module.components[componentName].components) {
        const _subcomponents = {};

        // eslint-disable-next-line
        Object.keys($module.components[componentName].components).forEach((subcomponentName) => {
          Object.assign(_subcomponents, {
            [subcomponentName]: {
              ...moduleBlueprint.components[componentName].components[subcomponentName],
              ...$module.components[componentName].components[subcomponentName]
            }
          });
        });

        _components[componentName].components = _subcomponents;
      } else if (_components[componentName].components) {
        delete _components[componentName].components;
      }
    });

    Object.assign(_package, {
      [moduleName]: {
        ...$module,
        ...moduleBlueprint,
        components: _components
      }
    });

    // loop over children
    if ($module.children) {
      const _children = {};

      Object.keys($module.children).forEach((childName) => {
        const _child = {};

        Object.keys($module.children[childName].components).forEach((grandChildName) => {
          const $grandChild = $module.children[childName].components[grandChildName];
          // eslint-disable-next-line
          const grandChildBlueprint = moduleBlueprint.children[childName].components[grandChildName];
          const _grandChild = {};

          Object.keys($grandChild.components).forEach((grandChildComponentName) => {
            const $grandGrandChild = $grandChild.components[grandChildComponentName];
            const grandGrandChildBlueprint = grandChildBlueprint.components[grandChildComponentName];
            const _grandGrandChild = {};

            // loop over grandGrandChildren (ex: TV Premium Channels, Telephone Lines)
            if ($grandGrandChild.components) {
              Object.keys($grandGrandChild.components).forEach((grandGrandChildComponentName) => {
                Object.assign(_grandGrandChild, {
                  [grandGrandChildComponentName]: {
                    ...$grandGrandChild.components[grandGrandChildComponentName],
                    ...grandGrandChildBlueprint.components[grandGrandChildComponentName]
                  }
                });
              });
            }

            Object.assign(_grandChild, {
              [grandChildComponentName]: {
                ...$grandChild.components[grandChildComponentName],
                ...grandChildBlueprint.components[grandChildComponentName],
                ...(Object.keys(_grandGrandChild).length && { components: _grandGrandChild }),
                ...($grandChild.components[grandChildComponentName].config && { config: $grandChild.components[grandChildComponentName].config })
              }
            });
          });

          Object.assign(_child, {
            [grandChildName]: {
              meta: grandChildBlueprint.meta,
              components: _grandChild
            }
          });
        });

        Object.assign(_children, {
          [childName]: {
            meta: moduleBlueprint.children[childName].meta,
            components: _child
          }
        });
      });

      _package[moduleName].children = _children;
    }

    // loop over sibling extra components
    if ($module.extra) {
      const _extra = {};

      Object.keys($module.extra).forEach((extraName) => {
        const $extra = $module.extra[extraName];
        const extraBlueprint = moduleBlueprint.extra[extraName];

        Object.assign(_extra, {
          [extraName]: {
            ...$extra,
            ...extraBlueprint,
            ...($extra.config && { config: $extra.config })
          }
        });
      });

      _package[moduleName].extra = _extra;
    }
  });


  if (packageBlueprint.config.features.enableGoogleGlobalSiteTag) {
    googleGlobalSiteTag.init(packageBlueprint.config.googleGlobalSiteTag.id);
  }

  if (packageBlueprint.config.features.enableCustomCoverageType) {
    dispatch('addresses/setCoverageType', packageBlueprint.config.customCoverageType, { root: true });
  }

  dispatch('simulation/setPackage', packageName, { root: true });
  dispatch('simulation/setActivePackage', _package, { root: true });
  dispatch('timeline/initialize', null, { root: true });
  dispatch('simulation/setStatus', 'initial', { root: true });

  return _package;
};

export default {
  initialize,
  setContent
};



// WEBPACK FOOTER //
// ./src/store/modules/packages/actions.js